'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductTourTeaser = exports.ProductTourTeaserUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactRouter = require('react-router');

var _multitrack = require('helpers/multitrack');

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductTourTeaserUnwrapped = exports.ProductTourTeaserUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(ProductTourTeaserUnwrapped, _PureComponent);

  function ProductTourTeaserUnwrapped() {
    (0, _classCallCheck3.default)(this, ProductTourTeaserUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (ProductTourTeaserUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(ProductTourTeaserUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProductTourTeaserUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      (0, _multitrack.ga)('Product Tour Teaser Module', 'Viewed product tour teaser module', null, 0, { nonInteraction: true });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'bg--' + (this.props.backgroundColor || 'white') },
        _react2.default.createElement(
          'div',
          { className: 'product-tour-teaser' },
          _react2.default.createElement(
            'div',
            { className: 'product-tour-teaser__content' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                tagName: 'h3',
                id: 'ProductTourTeaser.title',
                defaultMessage: 'See how it works'
              }),
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                tagName: 'p',
                id: 'ProductTourTeaser.body',
                defaultMessage: 'Get a glimpse in to how you can book classes, watch videos, and interact with a community to tap in to your healthiest self.'
              }),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'bt bt--primary bt--lg', to: '/features' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                  id: 'ProductTourTeaser.cta',
                  defaultMessage: 'Learn more'
                })
              )
            )
          ),
          _react2.default.createElement('div', { className: 'product-tour-teaser__image' })
        )
      );
    }
  }]);
  return ProductTourTeaserUnwrapped;
}(_react.PureComponent);

ProductTourTeaserUnwrapped.propTypes = {
  backgroundColor: _propTypes2.default.oneOf(['white', 'light'])
};

var ProductTourTeaser = exports.ProductTourTeaser = (0, _TrackDwell2.default)(ProductTourTeaserUnwrapped);